<div class="task-progress">
  <div class="step step-1">
    <div class="icon done" *ngIf="stage > 1"><i class="fa fa-check"></i></div>
    <div class="icon selected" *ngIf="stage === 1">1</div>
    <div class="icon" *ngIf="stage < 1">1</div>
    <label i18n="Connection wizard step 1 title at progress@@connectionWizardStep1ProgressTitle">Authentication</label>
  </div>
  <div class="connector">
    <svg style="height: 50px;" version="1.1" viewBox="0 0 21 42">
      <path
        style="fill:none;stroke:inherit;stroke-width:1.5px;stroke-linecap:round;stroke-linejoin:round;stroke-opacity:1;"
        d="m 16.5,34.5 -6,6.5 -6,-6.5 6,6.5 V 2"
      />
    </svg>
  </div>
  <div class="step step-2">
    <div class="icon done" *ngIf="stage > 2"><i class="fa fa-check"></i></div>
    <div class="icon selected" *ngIf="stage === 2">2</div>
    <div class="icon" *ngIf="stage < 2">2</div>
    <label i18n="Connection wizard step 2 title at progress@@connectionWizardStep2ProgressTitle">Registering application</label>
  </div>
  <div class="connector">
    <svg style="height: 50px;" version="1.1" viewBox="0 0 21 42">
      <path
        style="fill:none;stroke:inherit;stroke-width:1.5px;stroke-linecap:round;stroke-linejoin:round;stroke-opacity:1;"
        d="m 16.5,34.5 -6,6.5 -6,-6.5 6,6.5 V 2"
      />
    </svg>
  </div>
  <div class="step step-3">
    <div class="icon done" *ngIf="stage > 3"><i class="fa fa-check"></i></div>
    <div class="icon selected" *ngIf="stage === 3">3</div>
    <div class="icon" *ngIf="stage < 3">3</div>
    <label i18n="Connection wizard step 3 title at progress@@connectionWizardStep3ProgressTitle">Authorize</label>
  </div>
  <div class="connector">
    <svg style="height: 50px;" version="1.1" viewBox="0 0 21 42">
      <path
        style="fill:none;stroke:inherit;stroke-width:1.5px;stroke-linecap:round;stroke-linejoin:round;stroke-opacity:1;"
        d="m 16.5,34.5 -6,6.5 -6,-6.5 6,6.5 V 2"
      />
    </svg>
  </div>
  <div class="step step-4">
    <div class="icon done" *ngIf="stage > 4"><i class="fa fa-check"></i></div>
    <div class="icon selected" *ngIf="stage === 4">4</div>
    <div class="icon" *ngIf="stage < 4">4</div>
    <label i18n="Connection wizard step 4 title at progress@@connectionWizardStep4ProgressTitle">Connected</label>
  </div>
</div>
